import { disable, enable, hide, show } from './common';

export default class QuantityEdit {
    private baseElement: HTMLElement;
    private incrementButton: HTMLElement;
    private decrementButton: HTMLElement;
    private readonly quantityInput: HTMLInputElement;
    private readonly multiplyQuantityMsg: HTMLElement;
    private readonly orderButton: HTMLInputElement;
    
    private readonly min: number = 1;
    private readonly max: number;
    private readonly multiplier: number;

    private readonly onChangeCallback: (value: number) => void;

    constructor(baseElement: HTMLElement, onChange: (value: number) => void = null) {
        this.baseElement = baseElement;

        this.incrementButton = this.baseElement.querySelector('[data-action="increment-quantity"]');
        this.decrementButton = this.baseElement.querySelector('[data-action="decrement-quantity"]');
        this.quantityInput = this.baseElement.querySelector('[data-part="quantity-input"]');
        
        //Temporary solution - Element containing warning message is not a part of this component ... Needs rework in the future
        this.multiplyQuantityMsg = this.quantityInput.parentElement.parentElement.parentElement.querySelector("#multiply-quantity-warning-msg");
        this.orderButton = this.quantityInput.parentElement.parentElement.querySelector(".product-detail-informations__button");
        
        this.min = this.getAttributeNumberValue('min',1);
        this.max = this.getAttributeNumberValue('max',undefined);
        this.multiplier = this.getAttributeNumberValue('data-multiplier',undefined);
        this.onChangeCallback = onChange;
        this.initQuantityButtons();
        this.addChangeListener();
    }

    private getAttributeNumberValue(attributeName: string, defaultValue: number):number {
        const valueString = this.quantityInput.getAttribute(attributeName);
        if (!valueString) {
            return defaultValue;
        }

        const number = Number(valueString);
        if (isNaN(number)) {
            return defaultValue;
        }
        
        return number;
    }

    private addChangeListener() {
        this.quantityInput.addEventListener('change', (evt) => this.onChange(Number((evt.target as HTMLInputElement).value)))
    }

    private initQuantityButtons(): void {
        if (!this.quantityInput)
            return;

        this.initIncrementButton();
        this.initDecrementButton();
    }

    private initIncrementButton(): void {
        this.incrementButton.addEventListener('click', () => this.setValue(this.getValue() + 1)); 
    }

    private initDecrementButton(): void {
        this.decrementButton.addEventListener('click', () => this.setValue(this.getValue() - 1));
    }

    private onChange(value: number): void {
        if(value < this.min){
            this.setValue(this.min);
        }
        if (this.max && value > this.max) {
            this.setValue(this.max);
        }
        this.toggleMultiplyQuantityValidation(value);
        if (this.onChangeCallback)
            this.callbackIfValueStill(value);
    }

    private onChangeDelayed(value: number) {
        if (this.onChangeCallback)
            setTimeout(() => this.callbackIfValueStill(value), 1000);
    }

    private callbackIfValueStill(value: number) {
        if (this.getValue() !== value)
            return;

        this.onChangeCallback(this.getValue());
    }

    getValue(): number {
        return Number(this.quantityInput.value);
    }

    setValue(value: number) {
        if ((!value && value !== 0) || value < this.min || (this.max && value > this.max))
            return;
        
        this.toggleMultiplyQuantityValidation(value);

        const currentValue = this.getValue();
        this.quantityInput.value = value.toString();

        if (currentValue != value && this.onChangeCallback)
            this.onChangeDelayed(value);
    }
    
    toggleMultiplyQuantityValidation(value: number){
        //workaround for missing warning msg and button elements ... they are available in product detail only (in some cases)
        if(!this.multiplyQuantityMsg || !this.orderButton){ 
            return;
        }
        
        if(this.isMultiplyOrderQuantityValid(value)){
            hide(this.multiplyQuantityMsg);
            enable(this.orderButton);
        }else{
            show(this.multiplyQuantityMsg);
            disable(this.orderButton);
        }
    }
    
    isMultiplyOrderQuantityValid(value: number): boolean{
        if(!this.multiplier || this.multiplier == 0){
            return true;
        }
        
        return value % this.multiplier == 0;
    }
}
